/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../types.generated";
export type SendSlackSponsorshipUpdateMutationVariables = Types.Exact<{
  message: Types.Scalars["String"];
}>;

export type SendSlackSponsorshipUpdateMutation = Pick<
  Types.Mutation,
  "sendSlackSponsorshipUpdateMessage"
>;

export const SendSlackSponsorshipUpdateDocument = gql`
  mutation SendSlackSponsorshipUpdate($message: String!) {
    sendSlackSponsorshipUpdateMessage(message: $message)
  }
`;

/**
 * __useSendSlackSponsorshipUpdateMutation__
 *
 * To run a mutation, you first call `useSendSlackSponsorshipUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSlackSponsorshipUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSlackSponsorshipUpdateMutation, { data, loading, error }] = useSendSlackSponsorshipUpdateMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendSlackSponsorshipUpdateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendSlackSponsorshipUpdateMutation,
    SendSlackSponsorshipUpdateMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    SendSlackSponsorshipUpdateMutation,
    SendSlackSponsorshipUpdateMutationVariables
  >(SendSlackSponsorshipUpdateDocument, baseOptions);
}
export type SendSlackSponsorshipUpdateMutationHookResult = ReturnType<
  typeof useSendSlackSponsorshipUpdateMutation
>;
export type SendSlackSponsorshipUpdateMutationResult =
  ApolloReactCommon.MutationResult<SendSlackSponsorshipUpdateMutation>;
export type SendSlackSponsorshipUpdateMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SendSlackSponsorshipUpdateMutation,
    SendSlackSponsorshipUpdateMutationVariables
  >;
